import { createSelector } from '@ngrx/store';

import * as fromFeature from '../reducers';
import * as fromRelatedEvents from '../reducers/related-events.reducer';

export const getRelatedEventsState = createSelector(fromFeature.getEventState, (state: fromFeature.EventState) => state.relatedEvents);

export const getRelatedEventsEntities = createSelector(getRelatedEventsState, fromRelatedEvents.getRelatedEventsEntities);

export const getAllRelatedEvents = createSelector(getRelatedEventsEntities, entities => { return entities; });

export const getRelatedEventsLoading = createSelector(getRelatedEventsState, fromRelatedEvents.getRelatedEventsLoading);
export const getRelatedEventsLoaded = createSelector(getRelatedEventsState, fromRelatedEvents.getRelatedEventsLoaded);
export const getRelatedEventsError = createSelector(getRelatedEventsState, fromRelatedEvents.getRelatedEventsError);
